import {connect} from "react-redux";
import Messages_Search_Followings from "./Messages_Search_Followings";

const Messages_Search = (props) => {
    return(
        <>
            <form className={`messages_search main_content_section_${props.color_background}`} >
                <input type="search" placeholder="Search Users" id="search_button" className={`search_button profile_edit_form_input_color background_change_${props.color_background}`} />
            </form>
            <Messages_Search_Followings />
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        color_button: state.getColorButton.color_button
    }
}
export default connect(mapStateToProps)(Messages_Search);